module.exports = __webpack_public_path__ + "img/0116.b293a973.png";